import { getFlesher } from './index';
// // A base action with no payload.
// export interface Event<T extends string> {
//   event_name: T;
// }

// TODO: show this to Safwan to make sure we need all this stuff
export type BaseEvent = {
  // app_display_type?: string; // TODO: use TS to refine
  // app_docked_position?: string; // TODO: use TS to refine
  // app_is_disabled?: boolean;

  app_lang: string;
  // app_plan_type: string;
  // app_side?: string;
  // app_whitelabel: boolean;
  customer_uid: string;
  user_uid?: string;
  user_email?: string;
  // user_loggedin: boolean;
  // timestamp_created: number;

  // These comes from pageStats.getAll
  page_document_size_height?: number;
  page_document_size_width?: number;
  page_page_offset_left?: number;
  page_page_offset_top?: number;
  page_title?: string;
  page_viewport_height?: number;
  page_viewport_width?: number;
  page_language?: string; // TODO: use TS to refine this?
  page_timezone_offset?: number;
  page_timezone_string?: string;
  page_url?: string;
  page_referrer?: string;

  // These are removed in anon mode
  // app_page_url?: string;
  user_id_external?: string;
  // user_email?: string;
  // user_groups?: Array<string>;
  custom_attributes?: object | string | number;
};

export type IEvent<T extends string> = {
  event_name: T;
} & BaseEvent;

// An action with a payload.
export type EventWithContext<T extends string, C extends object> = IEvent<T> &
  C;

type FunctionType = (...args: any[]) => any;

// This is the type of where we define our actions.
type ActionCreatorsMapObject = { [eventCreator: string]: FunctionType };

// This extracts the action types from the map of action creator functions.
export type EventsUnion<A extends ActionCreatorsMapObject> = ReturnType<
  A[keyof A]
>;

type BaseContext = {
  [T: string]: string | object | undefined | number;
  custom_attributes?: string | object | number;
};

// This function creates an action either with a payload or not and retains it's
// type information
export function createEvent<T extends string>(eventName: T): IEvent<T>;
export function createEvent<T extends string, C extends BaseContext>(
  eventName: T,
  context: C
): EventWithContext<T, C>;
export function createEvent<T extends string, C extends BaseContext>(
  eventName: T,
  context?: C
): IEvent<T> | EventWithContext<T, C> {
  // This is what fill's in the basic event details.
  const flesher = getFlesher();
  if (!flesher) throw new Error('Need event flesher to create events');

  return context === undefined
    ? { ...flesher(), event_name: eventName }
    : { ...flesher(), event_name: eventName, ...(context as object) };
}
